import { Permission } from '@fabric-ui/components';
import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';
import { PAGE_PATHS } from '../../../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/identities/settings/rule-engine/create')({
  beforeLoad: ({ context, preload }) => {
    getTitleContextSlice('Create Rule');
    const path = PAGE_PATHS.RULE_ENGINE;
    const {
      validatePermissions,
      userPermissions: { hasAllowedPermission, isInternalRole },
    } = context;
    const isAllowed = hasAllowedPermission({ path }) || hasAllowedPermission({ path, permission: Permission.CREATE }) || isInternalRole;
    validatePermissions({ isAllowed, preload });
  },
  staticData: {
    owner: CodeOwner.IDNP,
  },
});
